export default "__VITE_ASSET__252b20d5__"